import { React, useState } from 'react';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';

const EnviarMensagem = () => {
    const [telefone, setTelefone] = useState('');
    const [codigoAtendimento, setCodigoAtendimento] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [message, setMessage] = useState('');
    const [statusAlerta, setStatusAlerta] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitEnviarMensagem (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            telefone,
            codigoAtendimento,
            mensagem
        });
        const response = await fetchFlask('chatgpt/sendFreeMessage', body);
        setMessage(response.message);
        setStatusAlerta(response.status);
        setOpenAlerta(true);
        if (response.status === 'success') {
            setTelefone('');
            setCodigoAtendimento('');
            setMensagem('');
        }
        setIsSubmit(false);
    }

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={statusAlerta}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Enviar Mensagem (MATRIX)
            </PageHeader>

            <form action='' method='POST' id='formEnviarMensagem' onSubmit={submitEnviarMensagem}>
                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        required
                        label='Telefone'
                        value={telefone}
                        onChange={(e) => setTelefone(e.target.value)}
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        required
                        label='Codigo de Atendimento'
                        value={codigoAtendimento}
                        onChange={(e) => setCodigoAtendimento(e.target.value)}
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        sx={{ width: '300px' }}
                        required
                        label='Mensagem'
                        value={mensagem}
                        onChange={(e) => setMensagem(e.target.value)}
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <SubmitButton isSubmit={isSubmit}>Enviar Mensagem</SubmitButton>
                </FormControl>
            </form>
        </Box>
    );
};

export default EnviarMensagem;
